<section class="explore-section explore-section--pad mx-auto flex w-full flex-col items-center py-12">
  <div class="explore-inner flex w-full flex-col items-center gap-8">
    <header class="explore-header flex w-full flex-col items-center gap-2 text-center">
      <span class="explore-badge inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-medium">
        <img [src]="badgeIconPath" alt="" aria-hidden="true" class="h-4 w-4 object-contain" />
        Discover healthcare assets
      </span>
      <h2 class="explore-title font-bold leading-tight">
        Explore datasets and models enabling collaboration across healthcare ecosystems.
      </h2>
      <p class="explore-subtitle leading-relaxed">
        Discover high-quality datasets designed to support research, policy development, and scalable
        digital health solutions.
      </p>
    </header>

    <div class="explore-content-shell flex w-full flex-col items-center gap-6">
      <div
        class="explore-tabs flex flex-wrap items-center justify-center gap-2"
        role="tablist"
        aria-label="Asset type"
      >
        <button
          type="button"
          role="tab"
          class="explore-tab explore-tab--datasets inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium"
          [class.explore-tab--active]="activeTab() === 'datasets'"
          [attr.aria-selected]="activeTab() === 'datasets'"
          (click)="switchTab('datasets')"
        >
          <img
            [src]="datasetsTabIconPath"
            alt=""
            aria-hidden="true"
            class="explore-tab-icon h-4 w-4 shrink-0 object-contain"
          />
          Datasets
        </button>
        <button
          type="button"
          role="tab"
          class="explore-tab explore-tab--models inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium"
          [class.explore-tab--active]="activeTab() === 'models'"
          [attr.aria-selected]="activeTab() === 'models'"
          (click)="switchTab('models')"
        >
          <img
            [src]="modelsTabIconPath"
            alt=""
            aria-hidden="true"
            class="explore-tab-icon h-4 w-4 shrink-0 object-contain"
          />
          Models
        </button>
      </div>

      <div class="explore-panel w-full">
        @if (activeTab() === 'datasets') {
          @if (datasetsLoading()) {
            <div class="explore-grid grid gap-6">
              @for (_ of [0, 1, 2]; track $index) {
                <app-skeleton variant="card" />
              }
            </div>
          } @else if (datasetCards().length === 0) {
            <p class="explore-empty text-center">No datasets available yet.</p>
          } @else {
            <div class="explore-grid grid gap-6">
              @for (card of datasetCards(); track card.id) {
                <app-dataset-card [card]="card" />
              }
            </div>
          }
        } @else {
          @if (modelsLoading()) {
            <div class="explore-grid grid gap-6">
              @for (_ of [0, 1, 2]; track $index) {
                <app-skeleton variant="card" />
              }
            </div>
          } @else if (modelCards().length === 0) {
            <p class="explore-empty text-center">No models available yet.</p>
          } @else {
            <div class="explore-grid grid gap-6">
              @for (card of modelCards(); track card.id) {
                <app-model-card [card]="card" />
              }
            </div>
          }
        }
      </div>

      <div class="explore-pager flex items-center justify-center gap-2">
        <button
          type="button"
          class="explore-pager-btn"
          aria-label="Previous page"
          [disabled]="!hasPrev()"
          (click)="prevPage()"
        >
          <img
            [src]="chevronIconPath"
            alt=""
            aria-hidden="true"
            class="explore-pager-chevron explore-pager-chevron--prev"
          />
        </button>
        <button
          type="button"
          class="explore-pager-btn"
          aria-label="Next page"
          [disabled]="!hasNext()"
          (click)="nextPage()"
        >
          <img
            [src]="chevronIconPath"
            alt=""
            aria-hidden="true"
            class="explore-pager-chevron explore-pager-chevron--next"
          />
        </button>
      </div>
    </div>
  </div>
</section>
